// For compatibility issues for pdfjs-dist 6.1.200+

let pdfjsLib;

export const getPDFLib = async () => {
    if (pdfjsLib) return pdfjsLib;

    try {
        pdfjsLib = await import('pdfjs-dist/webpack');
    } catch (err) {
        return null;
    }
    return pdfjsLib;
}